import { render } from "./AddPost.vue?vue&type=template&id=10878ca8&scoped=true"
import script from "./AddPost.vue?vue&type=script&lang=js"
export * from "./AddPost.vue?vue&type=script&lang=js"

import "./AddPost.vue?vue&type=style&index=0&id=10878ca8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10878ca8"]])

export default __exports__